module.exports = __webpack_public_path__ + "img/CKinLab_K.12b85106.png";